import { createContext } from "react";
export const LanguajeAppContext = createContext(null);
